var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('Header'),_c('UserForm',{on:{"userFilled":function($event){return _vm.save($event)}}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }